export class ProductionProcessDashboardReq{
    date?: any
    startDate? :any;
    endDate? :any
    unitId?:number
    constructor(date?:any,startDate? :any,endDate? :any, unitId?:number){
        this.date = date
        this.startDate=startDate
        this.endDate=endDate
        this.unitId = unitId
    }
}